import { StepId } from '../../config/steps';

export const BI_CONSTANTS = {
  FLOWS: {
    DS: 'ds',
  },
  SCREENS: {
    WELCOME_PAGE: 'welcome_page',
    CATEGORY_PAGE: 'category_page',
    THEME_PAGE: 'theme_page',
    SETUP_STORE_PAGE: 'setup_store_page',
    STORE_NAME_PAGE: 'store_name_page',
    LAUNCH_STORE_PAGE: 'launch_store_page',
    SITE_PREVIEW_PAGE: 'site_preview_page',
    MINIMAL_SETUP_PAGE: 'minimal_setup_page',
    UNKNOWN: 'unknown',
  },
  ACTION: {
    WELCOME_PAGE_NEXT: 'welcome_page_next',
    CATEGORY_PAGE_NEXT: 'category_page_next',
    THEME_PAGE_NEXT: 'theme_page_next',
    THEME_SELECTED: 'theme_selected',
    STORE_NAME_PAGE_NEXT: 'store_name_page_next',
  },
  BUTTON_NAME: {
    NEXT: 'next',
    PREVIOUS: 'previous',
    GET_STARTED: 'get_started',
    SELECT: 'select',
  },
} as const;

const STEP_TO_SCREEN_MAP: Record<StepId, string> = {
  [StepId.Welcome]: BI_CONSTANTS.SCREENS.WELCOME_PAGE,
  [StepId.Category]: BI_CONSTANTS.SCREENS.CATEGORY_PAGE,
  [StepId.Theme]: BI_CONSTANTS.SCREENS.THEME_PAGE,
  [StepId.SetupStore]: BI_CONSTANTS.SCREENS.SETUP_STORE_PAGE,
  [StepId.StoreName]: BI_CONSTANTS.SCREENS.STORE_NAME_PAGE,
  [StepId.LaunchStore]: BI_CONSTANTS.SCREENS.LAUNCH_STORE_PAGE,
  [StepId.SitePreview]: BI_CONSTANTS.SCREENS.SITE_PREVIEW_PAGE,
  [StepId.MinimalSetup]: BI_CONSTANTS.SCREENS.MINIMAL_SETUP_PAGE,
};

const PAGE_NAME_NORMALIZATION_MAP: Record<string, string> = {
  [BI_CONSTANTS.SCREENS.CATEGORY_PAGE]: 'CATEGORY_PAGE',
  [BI_CONSTANTS.SCREENS.THEME_PAGE]: 'TEMPLATE_SELECTION',
  [BI_CONSTANTS.SCREENS.STORE_NAME_PAGE]: 'STORE_NAME',
  [BI_CONSTANTS.SCREENS.SITE_PREVIEW_PAGE]: 'SITE_PREVIEW',
};

export function getScreenNameFromStepId(stepId: string | null): string {
  if (!stepId) {
    return BI_CONSTANTS.SCREENS.UNKNOWN;
  }

  const screenName = STEP_TO_SCREEN_MAP[stepId as StepId];
  if (!screenName) {
    return BI_CONSTANTS.SCREENS.UNKNOWN;
  }

  return PAGE_NAME_NORMALIZATION_MAP[screenName] || screenName;
}

export type ActionClickedParams = {
  action: (typeof BI_CONSTANTS.ACTION)[keyof typeof BI_CONSTANTS.ACTION];
  button_name?: (typeof BI_CONSTANTS.BUTTON_NAME)[keyof typeof BI_CONSTANTS.BUTTON_NAME];
  value?: string;
};
